/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Wrapped_Cover_Line_AllInputs */

const en_us2_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every workout done, ${i?.duration} of training.`)
};

const pt_br2_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todos os treinos feitos, com ${i?.duration} de treino.`)
};

const es_419_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todos los entrenamientos hechos, ${i?.duration} de entrenamiento.`)
};

const pt_pt2_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todos os treinos feitos, com ${i?.duration} de treino.`)
};

const fr_fr2_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toutes les séances faites, ${i?.duration} d'entraînement.`)
};

const de_de2_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle Trainings geschafft, ${i?.duration} Trainingszeit.`)
};

const it_it2_wrapped_cover_line_all = /** @type {(inputs: Wrapped_Cover_Line_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutti gli allenamenti fatti, ${i?.duration} di allenamento.`)
};

/**
* | output |
* | --- |
* | "Every workout done, {duration} of training." |
*
* @param {Wrapped_Cover_Line_AllInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_cover_line_all = /** @type {((inputs: Wrapped_Cover_Line_AllInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Cover_Line_AllInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_cover_line_all(inputs)
	if (locale === "es-419") return es_419_wrapped_cover_line_all(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_cover_line_all(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_cover_line_all(inputs)
	if (locale === "de-DE") return de_de2_wrapped_cover_line_all(inputs)
	if (locale === "it-IT") return it_it2_wrapped_cover_line_all(inputs)
	return en_us2_wrapped_cover_line_all(inputs)
});
export { wrapped_cover_line_all as "wrapped.cover_line_all" }